module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-8.936 16H18v7a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-7h-3.064c-.932 0-1.216-.38-.634-1.182l4.644-6.252c.58-.8 1.526-.73 2.108.07l4.644 6.146c.584.804.298 1.218-.634 1.218z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-square-3.js
// module id = 1479
// module chunks = 14